import { useQuery } from '@tanstack/react-query'
import { Link, useNavigate } from 'react-router-dom'
import { useSessionStore } from '@/store/session'
import { useLogout } from '@/features/auth/hooks'
import { authApi } from '@/features/auth/api'
import { privateQueryKey } from '@/features/auth/sessionCache'
import { Button } from '@/components/ui/Button'
import { ErrorState } from '@/components/ui/Feedback'

export default function ProfilePage() {
  const navigate = useNavigate()
  const user = useSessionStore((state) => state.user)
  const logout = useLogout()
  const security = useQuery({
    queryKey: privateQueryKey(user?.id ?? 0, 'account-security'),
    queryFn: () => authApi.security(),
    enabled: Boolean(user),
  })

  return (
    <section className="profile-page">
      <header className="flow-heading">
        <p className="eyebrow">Mi cuenta</p>
        <h1>Tu cuenta BsPOS</h1>
        <p>Administra tus empresas, licencias, terminales, timbres y pagos.</p>
      </header>

      <div className="profile-grid">
        <section className="account-summary" aria-labelledby="account-summary-heading">
          <h2 id="account-summary-heading">Tu sesión</h2>{security.isError && <ErrorState title="No pudimos consultar tu cuenta" retry={() => void security.refetch()} />}
          <dl>
            <div><dt>Nombre</dt><dd>{user?.fullName}</dd></div>
            <div><dt>Correo</dt><dd>{user?.email}</dd></div>
            <div><dt>Estado del correo</dt><dd>{security.isPending ? 'Comprobando…' : security.data?.emailVerified ? 'Verificado' : 'Pendiente de verificación'}</dd></div>
            <div><dt>Rol</dt><dd>{user?.roles.join(', ')}</dd></div>
          </dl>
          <Button type="button" emphasis="outline" intent="neutral" busy={logout.isPending} onClick={() => logout.mutate(undefined, { onSettled: () => navigate('/', { replace: true }) })}>Cerrar sesión</Button>
        </section>

        <section className="account-summary"><h2>Mis soluciones</h2><p>Elige una empresa para consultar licencias, administrar terminales, comprar timbres y revisar pagos o renovaciones.</p><Link className="ui-button" data-intent="primary" data-emphasis="solid" to="/empresas">Mis empresas y licencias</Link><p><Link to="/licencias">Ver planes</Link></p></section>
      </div>
    </section>
  )
}
